<template>
  <div class="min-h-screen bg-base-100 flex flex-col">
    <main :class="['flex-grow w-full']">
      <router-view />
    </main>

    <Footer />
  </div>
</template>

<script setup lang="ts">
import Footer from "@/components/Footer.vue";
</script>
